import { useEffect } from 'react';
import Raven from 'raven-js';

// @ts-expect-error Untyped dependency
import { setupCes } from 'wootric-nps/ces/ces-setup';
// @ts-expect-error Untyped dependency
import { setupCsat } from 'wootric-nps/csat/csat-setup';
const SurveyKey = {
  CES: 'ACADEMY',
  CSAT: 'ECOSYSTEM_ACADEMY'
};
const useWootricSurvey = (surveyType, skip) => {
  useEffect(() => {
    try {
      if (skip) return;
      if (surveyType === 'CSAT') {
        setupCsat(SurveyKey[surveyType]);
        return;
      }
      if (surveyType === 'CES') {
        setupCes(SurveyKey[surveyType]);
        return;
      }
      return;
    } catch (error) {
      Raven.captureException(error, {
        extra: {
          from: 'triggerWootricSurvey',
          surveyType,
          surveyKey: SurveyKey[surveyType]
        }
      });
    }
  }, [skip, surveyType]);
};
export default useWootricSurvey;